import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import isEqual from 'lodash/isEqual';
import { SelectDropdown } from '@adsk/bim360-matrix-react-components';
import { issueAttributesType } from '../constants/proptype-validation';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import FilterSearchIcon from './FilterSearchIcon';

class SingleSelectInlineEdit extends PureComponent {

  constructor(props) {
    super(props);
    const { issue, attributeName } = this.props;

    this.state = {
      value: issue[attributeName],
    };
    this.onUpdate = this.onUpdate.bind(this);
  }

  onUpdate(updateIssue) {
    const { issue, attributeName } = this.props;
    const { value } = this.state;
    if (!isEqual(value, issue[attributeName])) {
      updateIssue(this.state.value);
    }
  }

  render() {
    const { issue, options, className, attributeName, label, container, styleType, horizontalAlign } = this.props;
    return (
      <div>
        <IssueFieldInlineEdit
          issue={issue}
          className={className}
          data-testid={this.props['data-testid']}
          attributeName={attributeName}
          label={label}
          placeholder={T.translate('unspecifiedValue')}
          container={container}
          styleType={styleType}
          horizontalAlign={horizontalAlign}
        >
          {(currentValue, closeEditMode, updateIssue) => <SelectDropdown
            selectedOptions={options.find(option => option.key === currentValue)}
            valueKey="key"
            clearable
            autofocus
            openOnFocus
            backspaceRemoves={false}
            options={options}
            searchable
            searchPlaceholder={T.translate('search')}
            searchIcon={<FilterSearchIcon />}
            onClose={closeEditMode}
            onChange={(option) => {
              const key = option && option.key ? option.key : null;
              this.setState({ value: key }, () => { this.onUpdate(updateIssue); });
            }}

          />}
        </IssueFieldInlineEdit>
      </div>
    );
  }
}

SingleSelectInlineEdit.displayName = 'SingleSelectInlineEdit';


SingleSelectInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  attributeName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  options: PropTypes.array.isRequired,
  infoMessage: PropTypes.string,
  container: PropTypes.object,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  horizontalAlign: PropTypes.bool,
};

export default SingleSelectInlineEdit;
